<template>
	<div class="about">
		<vue-headful :title="$t('pageTitle')" :description="$t('pageTitle')" />
		<confirm ref="confirm"></confirm>
		<v-breadcrumbs :items="breadcrumbsItems">
			<template v-slot:divider>
				<v-icon class="secondary--text text--lighten-2"
					>fas fa-caret-right</v-icon
				>
			</template>
		</v-breadcrumbs>
		<v-select
			v-model="selectedMonth"
			:items="monthsOptions"
			item-text="label"
			item-value="value"
			label="Select Month"
			@change="LoadLogs"
			style="width: 30%"
		></v-select>
		<v-skeleton-loader type="list-item@10" v-if="LoadingData"></v-skeleton-loader>

		<v-simple-table style="min-width: 300px" v-if="!LoadingData">
			<template v-slot:default>
				<thead>
					<tr>
						<th class="text-left">
							Data
						</th>
						<th class="text-left">
							Utente
						</th>
						<th class="text-left">
							Numero operazioni
						</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="item in data" :key="item.Date + item.UserId">
						<td>
							{{ item.Date | formatDate }}
						</td>
						<td class="text-left">
							{{ item.UserId }}
						</td>
						<td class="text-left">
							{{ item.Count }}
						</td>
					</tr>
				</tbody>
			</template>
		</v-simple-table>
	</div>
</template>
<script>
import confirm from "@/components/Shared/Common/Confirm.vue";
import { mapActions } from "vuex";
import CrudClient from "@/services/CrudClient";

export default {
	name: "FaceApiUsageLog",
	components: { confirm },
	data() {
		return {
			breadcrumbsItems: [
				{
					text: "Home",
					disabled: false,
					exact: true,
					to: "/"
				}
			],

			data: [],
			selectedMonth: new Date().toISOString().slice(0, 7), // this month by default,
			LoadingData: false

		};
	},
	created() {
		this.FacePersonService = new CrudClient("Face/Person");
	},
	computed: {
		monthsOptions() {
			const months = [];
			for (let i = 0; i < 13; i++) {
				const date = new Date();
				date.setMonth(date.getMonth() - i);
				months.push({
					label: date.toLocaleDateString(this.$i18n.locale, { year: "numeric", month: "long" }),
					value: date.toISOString().slice(0, 7) // YYYY-MM format
				});
			}
			return months;
		}
	},
	async mounted() {
		this.breadcrumbsItems.push(
			{
				text: this.$t("systemSettings"),
				disabled: false,
				exact: true,
				to: "/SystemSettings"
			},
			{
				text: this.$t("pageTitle"),
				disabled: true,
				exact: true,
				to: "/SystemSettings/LogViewer"
			}
		);
		this.$log.info("ApplicationLog Viewer Mounted");

		await this.LoadLogs();
	},
	methods: {
		...mapActions(["snackSuccess", "snackError"]),

		async LoadLogs() {
			try {
				this.LoadingData = true;
				this.data = await this.FacePersonService.Get("LogUsage?period=" + this.selectedMonth);
			} finally {
				this.LoadingData = false;
			}
		}
	}
};
</script>

<style scoped lang="scss"></style>
<i18n>
{
	"it": {
		"pageTitle": "Face Api Log",
		"systemSettings": "System Settings"
	}
}
</i18n>
